import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, default: () => ({}) }
  },
  mounted: function() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler: function() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};